import { useEffect, useRef, useState } from "react";
import { motion, AnimatePresence, useViewportScroll } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import FavouritesMenuIconComponent from "./FavouritesMenuIconComponent";
import Search2Component from "./Search2Component";
import { Twirl as Hamburger } from "hamburger-react";
import OffCanvasMenu from "./OffCanvasMenu";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import setShowOffCanvas from "../actions/header/setShowOffCanvas";
import { fadeAnimation } from "../animations";
import useWindowSize from "../hooks/useWindowSize";
import isMobile from "../modules/isMobile";
import clsx from "clsx";

const ResponsiveHeader = (props) => {
  const [showSearch, setShowSearch] = useState(false);
  const [showBackground, setShowBackground] = useState(false);
  const [isFrontpage, setIsFrontpage] = useState(true);
  const [hasMiniCart, setHasMiniCart] = useState(false);
  const pathname = window?.location?.pathname;
  const isBelowDesktop = isMobile();
  console.log("📲 RESP HEADER PATHNAME", pathname);

  const headerRef = useRef(null);
  const searchRef = useRef(null);

  const windowsSize = useWindowSize();

  const { scrollY } = useViewportScroll();

  const fadeInFromLeftAnimation = {
    hidden: {
      opacity: 0,
      x: -200,
    },
    visible: {
      opacity: 1,
      x: 0,
    },
    exit: {
      opacity: 0,
      x: -200,
    },
  };

  useEffect(() => {
    if (pathname.length !== 1 && pathname !== "/") {
      setIsFrontpage(false);
    }
  }, []);

  const determineIcon = (link, index) => {
    switch (link.slug) {
      case "favourites":
        return (
          <a key={index} href={link.url} className="flex items-center ml-3">
            <FavouritesMenuIconComponent showBackground={showBackground} />
          </a>
        );

      case "cart":
        return (
          <div
            id="cart-contents"
            className="cart-contents trigger flex items-center relative ml-[19px]"
            key={index}
          >
            {!isBelowDesktop ? (
              <div className="block relative pointer-events-none">
                <FontAwesomeIcon
                  icon={["fal", "shopping-bag"]}
                  className={clsx(
                    "shopping-bag-no-product transition-colors ease-in-out duration-500",
                    isFrontpage
                      ? showBackground
                        ? "text-gray-light fill-current"
                        : "text-white fill-current"
                      : "text-gray-light fill-current"
                  )}
                />
                <div className="absolute top-1/2 left-1/2">
                  <div
                    id="cart-icon-count"
                    className={clsx(
                      "rounded-full flex justify-center items-center w-[18px] h-[18px]",
                      count > 0 ? "bg-gray-light" : "bg-transparent"
                    )}
                  >
                    {count > 0 && count <= 9 && (
                      <span className="number">{count}</span>
                    )}
                    {count > 9 && <span className="circle" />}
                  </div>
                </div>
              </div>
            ) : (
              <a href={link.url} className="flex relative">
                <FontAwesomeIcon
                  icon={["fal", "shopping-bag"]}
                  className={clsx(
                    "shopping-bag-product transition-colors ease-in-out duration-500",
                    isFrontpage
                      ? showBackground
                        ? "text-gray-light fill-current"
                        : "text-white fill-current"
                      : "text-gray-light fill-current"
                  )}
                />
                <div className="absolute top-1/2 left-1/2">
                  <div
                    id="cart-icon-count"
                    className={clsx(
                      "rounded-full flex justify-center items-center w-[18px] h-[18px]",
                      count > 0 ? "bg-gray-light" : "bg-transparent"
                    )}
                  >
                    {count > 0 && count <= 9 && (
                      <span className="number">{count}</span>
                    )}
                    {count > 9 && <span className="circle" />}
                  </div>
                </div>
              </a>
            )}
            {!isBelowDesktop && (
              <div id="mini-cart" className="minicart">
                <p
                  id="mini-cart-count"
                  className="from-responsive-header"
                >{`${count} products in bag`}</p>
                <ul className="cart_list product_list_widget">
                  <li className="mini_cart_item"></li>
                </ul>
                <p className="woocommerce-mini-cart__total total">
                  <span>Order total</span>
                  <span className="woocommerce-Price- ">
                    <bdi>
                      <span className="woocommerce-Price-currencySymbol"></span>
                    </bdi>
                  </span>
                </p>
                <div className="approx-price-wrapper">
                  <input
                    type="hidden"
                    className="approx-price-hidden-field"
                    {...{ "data-type": "minicart", "data-shipping": "no" }}
                    value="false"
                  />
                  <p className="price price--approx"></p>
                  <select id="currencyChanger"></select>
                </div>
                <p className="buttons">
                  <button
                    className="button wc-forward"
                    onClick={() =>
                      (window.location.href = `${window.location.origin}/cart`)
                    }
                  >
                    View Bag
                  </button>
                  <button
                    className="button checkout wc-forward"
                    onClick={() =>
                      (window.location.href = `${window.location.origin}/checkout`)
                    }
                  >
                    Proceed to checkout
                  </button>
                </p>
              </div>
            )}
          </div>
        );

      default:
        return;
    }
  };

  useEffect(() => {
    return scrollY.onChange((yValue) => {
      const miniCartEl = document.querySelector(".minicart.active");
      // console.log("miniCartEl", miniCartEl);

      if (miniCartEl) {
        setHasMiniCart(true);
      } else {
        setHasMiniCart(false);
      }

      if (yValue > 40) {
        setShowBackground(true);
      } else {
        setShowBackground(false);
      }
    });
  }, []);

  // console.log('showBackground', showBackground);

  return (
    <>
      <div
        className={clsx(
          "flex items-center justify-between w-full pl-1 pr-8 py-1 relative transition-colors ease-in-out duration-500",
          isFrontpage
            ? showBackground
              ? "bg-tpc-darker"
              : "bg-transparent"
            : "bg-tpc-darker"
        )}
        ref={headerRef}
      >
        <AnimatePresence>
          {isFrontpage && !showBackground && (
            <motion.div
              className="w-full bg-white absolute bottom-0 left-0 h-[1px]"
              initial="initial"
              animate="animate"
              exit="exit"
              variants={fadeAnimation}
            />
          )}
        </AnimatePresence>
        <div className="flex items-center">
          <Hamburger
            size={18}
            color={
              isFrontpage
                ? hasMiniCart
                  ? "#333333"
                  : showBackground
                  ? "#333333"
                  : "#ffffff"
                : "#333333"
            }
            toggled={props.showOffCanvas}
            onToggle={(toggled) => {
              toggled
                ? props.actions.setShowOffCanvas(toggled)
                : props.actions.setShowOffCanvas(toggled);
            }}
          />
          <a className="flex items-center h-6 w-6 cursor-pointer ml-1">
            <FontAwesomeIcon
              icon={["fal", "search"]}
              className={clsx(
                "search-icon transition-colors ease-in-out duration-500",
                isFrontpage
                  ? showBackground
                    ? "text-black fill-current"
                    : "text-white fill-current"
                  : "text-black fill-current"
              )}
              onClick={() => setShowSearch(!showSearch)}
            />
          </a>
        </div>
        {
          // sebastianp task 2401504982 new logo is shwowing over the 380px (added new breakpoint - xs-380px), the old one below 380px
          // hidden xs:block
        }
        {windowsSize?.width && (
          <a
            href="/"
            className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 hidden [@media(min-width:380px)]:block"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 147 20"
              className="w-[146px] [@media(min-width:430px)]:w-[190px] h-[20px] [@media(min-width:430px)]:h-[26px]"
              width={windowsSize.width <= 430 ? 146 : 190}
              height={windowsSize.width <= 430 ? 20 : 26}
            >
              <motion.path
                d="M4.63749994,12.3436499 L4.63749994,6.93445973 L7.81954165,6.97761399 C8.06449882,6.82539715 8.10932758,5.75674078 7.86437041,5.51664618 L4.63749994,5.7128019 L4.70394257,2.9422985 C4.63749994,2.79008166 3.81377141,2.76811222 3.70250001,2.9422985 C2.92360024,4.36011205 1.56672963,5.55980044 0.141815352,6.03998964 C-0.0358986759,6.12708278 -0.0583130578,6.86855141 0.141815352,6.97761399 L1.49948648,6.97761399 L1.32177245,13.2161505 C1.32177245,14.9831213 2.72347183,16.0957165 4.6823287,16.0957165 C6.55152805,16.0957165 8.06449882,14.8301198 8.6208558,13.2600894 C8.70971281,12.8450239 8.15335583,12.5617751 7.84195603,12.8238391 C7.3528422,13.6963397 6.70682769,14.0235275 6.0616137,14.0235275 C5.23868568,14.0235275 4.63749994,13.4562451 4.63749994,12.3436499 L4.63749994,12.3436499 Z M13.5119941,8.15533294 C13.9570797,7.58883522 14.6030942,7.23967803 15.2923365,7.23967803 C16.293779,7.23967803 16.8277216,7.89405352 16.8277216,9.00664877 L16.8277216,14.8301198 L15.7150077,15.0262755 C15.5821224,15.179277 15.5821224,15.7465593 15.7150077,15.8775914 L21.3898488,15.8775914 C21.5235346,15.7465593 21.5235346,15.179277 21.3898488,15.0262755 L20.255521,14.8301198 L20.255521,8.3734581 C20.255521,6.34520794 19.0315357,5.167489 17.3624647,5.167489 C15.648565,5.167489 14.2908939,6.41111627 13.5119941,7.52292689 L13.5119941,0.106671392 C13.3566945,-0.0463300705 12.7779231,-0.0243606297 12.6666517,0.106671392 C11.976609,0.695923178 10.3747812,1.32832922 8.74973849,1.5025155 C8.59443885,1.56842383 8.54961009,2.17886043 8.74973849,2.26595357 C9.8184242,2.72417333 10.0849952,2.8771748 10.0849952,3.37854882 L10.0849952,14.8301198 L8.97228129,15.0262755 C8.83859551,15.179277 8.83859551,15.7465593 8.97228129,15.8775914 L14.6247081,15.8775914 C14.7808082,15.7465593 14.7808082,15.179277 14.6247081,15.0262755 L13.5119941,14.8301198 L13.5119941,8.15533294 Z M32.0030586,12.2565568 C31.9806443,11.9513385 31.5355587,11.798337 31.2465732,11.9513385 C30.5565305,13.1290574 29.6215306,13.4993994 28.442374,13.4993994 C26.7957174,13.4993994 25.2819461,12.3656193 25.1266465,10.0753051 L31.8245441,10.0753051 C32.1367444,7.43583375 30.6229731,5.167489 27.507374,5.167489 C24.4366037,5.167489 22.1887614,7.95917722 22.1887614,10.8818975 C22.1887614,13.9795886 24.391775,16.0957165 27.3072456,16.0957165 C29.8440734,16.0957165 31.5579731,14.3719001 32.0030586,12.2565568 L32.0030586,12.2565568 Z M27.3072456,6.21417592 C28.620088,6.21417592 28.9314878,7.67592836 28.7761882,9.00664877 L25.1266465,9.07177247 C25.2819461,7.26164747 26.128089,6.21417592 27.3072456,6.21417592 L27.3072456,6.21417592 Z M40.8375271,7.54489633 L40.8815554,5.23261269 C40.7262557,5.08039586 40.12507,5.1023653 40.0137986,5.23261269 C39.3237558,5.82186448 37.7443424,6.45427053 36.0968854,6.62924143 C35.9415857,6.69436513 35.9191713,7.28283229 36.0968854,7.37071005 C37.1879855,7.85011464 37.4105283,8.0031161 37.4105283,8.50449012 L37.4105283,18.9752825 L36.2978143,19.1494688 C36.1641285,19.3024703 36.1641285,19.868968 36.2978143,20 L42.6178695,20 C42.7507547,19.868968 42.7507547,19.3024703 42.6178695,19.1494688 L40.8375271,18.9752825 L40.8375271,15.3754327 C41.3938841,15.8556219 42.1279551,16.0957165 42.9957119,16.0957165 C45.933597,16.0957165 48.3815677,13.739494 48.3815677,10.0313663 C48.3815677,7.26164747 46.8461825,5.167489 44.353383,5.167489 C42.8179979,5.167489 41.415498,6.34520794 40.8375271,7.54489633 L40.8375271,7.54489633 Z M40.8375271,8.17730238 C41.1929552,7.58883522 41.8389697,7.10864601 42.6394833,7.10864601 C44.0419832,7.10864601 44.8649112,8.59158326 44.8649112,11.0348989 C44.8649112,13.4993994 43.7746117,14.9831213 42.5065981,14.9831213 C41.7717266,14.9831213 41.1040982,14.3938695 40.8375271,13.3471826 L40.8375271,8.17730238 Z M49.6119571,10.6425875 C49.6119571,13.6304314 52.0375134,16.0957165 55.0642555,16.0957165 C58.1126114,16.0957165 60.5381678,13.6304314 60.5381678,10.6425875 C60.5381678,7.63198948 58.1126114,5.167489 55.0642555,5.167489 C52.0375134,5.167489 49.6119571,7.63198948 49.6119571,10.6425875 L49.6119571,10.6425875 Z M53.2839132,10.6425875 C53.2839132,7.89405352 53.5504842,6.28008425 55.0642555,6.28008425 C56.5996407,6.28008425 56.8662117,7.89405352 56.8662117,10.6425875 C56.8662117,13.369152 56.5996407,14.9831213 55.0642555,14.9831213 C53.5504842,14.9831213 53.2839132,13.369152 53.2839132,10.6425875 L53.2839132,10.6425875 Z M65.9080132,15.0262755 C64.5951709,15.0262755 63.5713139,14.0666817 62.4145717,11.8203064 C62.1247858,11.6892744 61.6132576,11.9513385 61.5908432,12.1906484 L62.0167164,15.0176447 L62.0359288,15.0262755 C62.9036856,15.680651 64.3950425,16.0957165 65.8863994,16.0957165 C68.3783983,16.0957165 70.4261122,14.5249015 70.4261122,12.4966514 C70.4261122,8.85364731 64.8625424,9.48605335 64.8625424,7.45780319 C64.8625424,6.71633457 65.4188994,6.2581148 66.2866562,6.2581148 C67.5330559,6.2581148 68.6681843,7.43583375 69.3574265,8.94074045 C69.5583554,9.13689617 70.2035694,8.94074045 70.181155,8.67946103 L69.7768956,6.25497631 L69.7584838,6.23614536 C69.2021269,5.7128019 67.8444557,5.167489 66.420342,5.167489 C64.2389423,5.167489 62.2144433,6.60727199 62.2144433,8.59158326 C62.2144433,12.3216805 67.5330559,11.4060255 67.5330559,13.6304314 C67.5330559,14.4809626 66.8205988,15.0262755 65.9080132,15.0262755 L65.9080132,15.0262755 Z M90.34049,12.2565568 C90.3180756,11.9513385 89.87299,11.798337 89.5840046,11.9513385 C88.8939618,13.1290574 87.9589619,13.4993994 86.7798053,13.4993994 C85.1331488,13.4993994 83.620178,12.3656193 83.4640778,10.0753051 L90.1627759,10.0753051 C90.4741757,7.43583375 88.9604045,5.167489 85.8448054,5.167489 C82.7740351,5.167489 80.5261928,7.95917722 80.5261928,10.8818975 C80.5261928,13.9795886 82.7300068,16.0957165 85.644677,16.0957165 C88.1815047,16.0957165 89.8954044,14.3719001 90.34049,12.2565568 L90.34049,12.2565568 Z M85.644677,6.21417592 C86.9575193,6.21417592 87.2697196,7.67592836 87.1136195,9.00664877 L83.4640778,9.07177247 C83.620178,7.26164747 84.4655204,6.21417592 85.644677,6.21417592 L85.644677,6.21417592 Z M96.0481522,5.23261269 C95.8928526,5.08039586 95.2916668,5.1023653 95.1803954,5.23261269 C94.4903527,5.82186448 92.9109393,6.45427053 91.2642827,6.62924143 C91.1081825,6.69436513 91.0857682,7.28283229 91.2642827,7.37071005 C92.3545823,7.85011464 92.5771251,8.0031161 92.5771251,8.50449012 L92.5771251,14.8301198 L91.4644111,15.0262755 C91.3307253,15.179277 91.3307253,15.7465593 91.4644111,15.8775914 L97.6956093,15.8775914 C97.8284945,15.7465593 97.8284945,15.179277 97.6956093,15.0262755 L96.0041239,14.8301198 L96.0041239,8.70064584 C96.5380665,7.89405352 97.1608662,7.26164747 97.5170947,7.26164747 C97.7396375,7.26164747 97.8509089,7.37071005 97.9181521,7.74105206 C98.0734517,8.48252068 98.6522231,8.91877101 99.4311228,8.91877101 C100.387737,8.91877101 101.189051,8.19927182 101.189051,7.10864601 C101.189051,6.0180202 100.521422,5.167489 99.2534088,5.167489 C98.0734517,5.167489 96.8942951,6.19299111 96.0041239,7.8281452 L96.0481522,5.23261269 Z M110.423776,6.34520794 C111.247505,6.34520794 111.737419,6.73751939 111.737419,7.23967803 C111.737419,7.6978978 110.735976,7.6978978 110.735976,8.89758619 C110.735976,9.66102425 111.358776,10.227522 112.182505,10.227522 C113.205561,10.227522 113.962847,9.48605335 113.962847,8.28636496 C113.962847,6.47623997 112.493904,5.167489 110.268476,5.167489 C106.819063,5.167489 104.415921,7.89405352 104.415921,10.9478058 C104.415921,14.0447123 106.574106,16.0957165 109.511991,16.0957165 C112.026404,16.0957165 113.740304,14.3067764 114.18539,12.2345873 C114.162975,11.929369 113.71789,11.7763675 113.428104,11.929369 C112.738862,13.0851185 111.803862,13.5433383 110.624705,13.5433383 C108.910805,13.5433383 107.397835,12.299711 107.397835,9.92230367 C107.397835,7.7630215 108.821948,6.34520794 110.423776,6.34520794 L110.423776,6.34520794 Z M120.729589,15.8775914 C120.863274,15.7465593 120.863274,15.179277 120.729589,15.0262755 L119.616875,14.8301198 L119.616875,0.106671392 C119.461575,-0.0463300705 118.882804,-0.0243606297 118.771532,0.106671392 C118.08149,0.695923178 116.479662,1.32832922 114.832205,1.5025155 C114.699319,1.56842383 114.654491,2.17886043 114.832205,2.26595357 C115.923305,2.72417333 116.189876,2.8771748 116.189876,3.37854882 L116.189876,14.8301198 L115.077162,15.0262755 C114.943476,15.179277 114.943476,15.7465593 115.077162,15.8775914 L120.729589,15.8775914 Z M129.936296,16.0957165 C130.89291,15.5715884 132.205752,15.2012464 133.830795,15.1141533 C134.008509,15.048245 134.008509,14.3507152 133.830795,14.2628375 C132.739695,13.9144649 132.539566,13.9356497 132.539566,13.4342757 L132.539566,5.32049046 C131.405239,5.51664618 129.134982,5.69083246 127.777311,5.73477134 C127.643625,5.86580336 127.643625,6.54136367 127.777311,6.69436513 L129.112567,6.86855141 L129.112567,13.107088 C128.667482,13.6743703 128.111125,14.0235275 127.332225,14.0235275 C126.464468,14.0235275 125.908111,13.369152 125.908111,12.2565568 L125.908111,5.32049046 C124.772983,5.51664618 122.703655,5.69083246 121.368399,5.73477134 C121.234713,5.86580336 121.234713,6.54136367 121.368399,6.69436513 L122.481113,6.86855141 L122.481113,12.8889628 C122.481113,14.917213 123.705098,16.0957165 125.351754,16.0957165 C127.065654,16.0957165 128.311253,14.8740587 129.112567,13.7614634 L129.068539,16.0957165 L129.936296,16.0957165 Z M139.865867,16.0957165 C143.537023,16.0957165 146.363636,13.739494 146.363636,10.0313663 C146.363636,7.26164747 144.805837,5.167489 142.313037,5.167489 C140.777652,5.167489 139.398367,6.3232385 138.797181,7.54489633 L138.797181,0.106671392 C138.641882,-0.0463300705 138.040696,-0.0243606297 137.929425,0.106671392 C137.239382,0.695923178 135.659168,1.32832922 134.034926,1.5025155 C133.857212,1.56842383 133.834797,2.17886043 134.034926,2.26595357 C135.102811,2.72417333 135.370183,2.8771748 135.370183,3.37854882 L135.370183,14.7430267 C136.371625,15.6594662 138.329681,16.0957165 139.865867,16.0957165 L139.865867,16.0957165 Z M75.32815,2.85313883 C75.433641,2.67422386 76.2145776,2.69678972 76.2775686,2.85313883 L76.2775686,2.85313883 L76.2145776,5.69885386 L79.273815,5.49737304 C79.5060469,5.74398556 79.4635469,6.84165304 79.2313151,6.99800216 L79.2313151,6.99800216 L76.2145776,6.95367638 L76.2145776,12.5097113 C76.2145776,13.6525105 76.7845322,14.235193 77.5647099,14.235193 C78.1764056,14.235193 78.7888602,13.899123 79.252565,13.0029364 C79.5477879,12.733758 80.0752426,13.0246963 79.9910017,13.4510297 C79.4635469,15.0636821 78.0291736,16.3636364 76.2570775,16.3636364 C74.3999815,16.3636364 73.0710991,15.2208372 73.0710991,13.405898 L73.0710991,13.405898 L73.2395811,6.99800216 L71.9531987,6.99800216 C71.7627078,6.88597882 71.7839578,6.12438134 71.9531987,6.03492386 C73.303331,5.54169882 74.5897134,4.30944216 75.32815,2.85313883 Z M140.599938,7.10864601 C142.001638,7.10864601 142.825366,8.59158326 142.825366,11.0348989 C142.825366,13.4993994 141.690238,15.1353381 140.421424,15.1353381 C139.687353,15.1353381 139.064553,14.5688404 138.797181,13.739494 L138.797181,8.17730238 C139.15341,7.58883522 139.798624,7.10864601 140.599938,7.10864601 Z"
                className={clsx(
                  "header-logo-big transition-colors ease-in-out duration-500",
                  isFrontpage
                    ? showBackground
                      ? "text-black fill-current"
                      : "text-white fill-current"
                    : "text-black fill-current"
                )}
              />
            </svg>
          </a>
        )}
        <a
          href="/"
          className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 block [@media(min-width:380px)]:hidden"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 506 274"
            width="48"
            height="26"
          >
            <motion.path
              d="M72.415 151.728V65.553l49.687.687c3.825-2.425 4.525-19.45.7-23.275L72.415 46.09l1.037-44.137c-1.037-2.425-13.9-2.775-15.637 0-12.163 22.587-33.35 41.7-55.6 49.35-2.775 1.387-3.125 13.2 0 14.937h21.2l-2.775 99.384c0 28.154 21.887 45.879 52.475 45.879 29.187 0 52.812-20.163 61.5-45.18 1.387-6.612-7.3-11.12-12.163-6.95-7.637 13.905-17.725 19.117-27.8 19.117-12.85 0-22.237-9.041-22.237-26.762zm145.112-76.45l.688-36.838c-2.425-2.425-11.813-2.075-13.55 0-10.775 9.388-35.438 19.463-61.163 22.25-2.425 1.038-2.775 10.425 0 11.813 17.038 7.637 20.513 10.075 20.513 18.062v166.813l-17.375 2.775c-2.088 2.437-2.088 11.462 0 13.55h98.687c2.075-2.088 2.075-11.113 0-13.55l-27.8-2.775v-57.35c8.688 7.65 20.15 11.475 33.7 11.475 45.875 0 84.1-37.542 84.1-96.613 0-44.125-23.975-77.487-62.9-77.487-23.975 0-45.862 18.762-54.9 37.875zm0 10.075c5.563-9.375 15.638-17.025 28.15-17.025 21.888 0 34.738 23.625 34.738 62.55 0 39.258-17.025 62.9-36.825 62.9-11.475 0-21.9-9.388-26.063-26.067V85.353zM446.39 56.165c12.85 0 20.5 6.263 20.5 14.25 0 7.3-15.637 7.3-15.637 26.413 0 12.162 9.725 21.187 22.587 21.187 15.988 0 27.8-11.812 27.8-30.925 0-28.837-22.937-49.687-57.687-49.687-53.863 0-91.388 43.437-91.388 92.087 0 49.334 33.7 82.013 79.575 82.013 39.263 0 66.025-28.5 72.975-61.513-.35-4.862-7.3-7.3-11.812-4.862-10.775 18.408-25.375 25.708-43.788 25.708-26.762 0-50.387-19.808-50.387-57.683 0-34.4 22.237-56.988 47.262-56.988z"
              className={clsx(
                "header-logo-small transition-colors ease-in-out duration-500",
                isFrontpage
                  ? showBackground
                    ? "text-black fill-current"
                    : "text-white fill-current"
                  : "text-black fill-current"
              )}
            />
          </svg>
        </a>
        <div id="close_cart_on_leave" className="flex items-center -ml-3">
          {megaMenuIcons.map((icon, index) => {
            return determineIcon(icon.mega_menu_icon_link_to, index);
          })}
        </div>
      </div>

      <AnimatePresence>
        {props.showOffCanvas && (
          <motion.div
            className="fixed top-0 left-0 h-screen w-screen bg-tpc-darker"
            initial="hidden"
            animate="visible"
            exit="exit"
            variants={fadeInFromLeftAnimation}
            transition={{ type: "tween" }}
          >
            <OffCanvasMenu />
          </motion.div>
        )}
      </AnimatePresence>

      <AnimatePresence>
        {showSearch && (
          <motion.div
            ref={searchRef}
            key="index"
            className="fixed top-0 left-0 w-full px-4 pb-4 bg-tpc-light h-screen"
            initial="hidden"
            animate="visible"
            exit="exit"
            variants={fadeInFromLeftAnimation}
            transition={{ type: "tween" }}
          >
            <div className="relative">
              <div className="absolute left-0 top-1/2 transform -translate-y-1/2">
                <FontAwesomeIcon
                  icon={["fal", "search"]}
                  fixedWidth
                  className="text-base"
                />
              </div>
              <Search2Component />
              <div className="absolute right-0 top-1/2 transform -translate-y-1/2">
                <FontAwesomeIcon
                  icon={["fal", "times"]}
                  fixedWidth
                  onClick={() => setShowSearch(false)}
                  className="cursor-pointer text-base"
                />
              </div>
            </div>
            <div className="flex flex-col">
              {searchQuickLinksTitle && (
                <div className="mt-5">
                  <p className="font-display-regular tracking-wider uppercase text-black text-[10px]">
                    {searchQuickLinksTitle}
                  </p>
                  <span className="block w-11 bg-gray my-2 h-[1px]"></span>
                </div>
              )}
              {searchQuickLinksLinks.map((quickLink, index) => (
                <a
                  key={index}
                  href={
                    quickLink.search_quick_links_link_custom_link_to
                      ? quickLink.search_quick_links_link_custom_link_to
                      : quickLink.search_quick_links_link_link_to.url
                  }
                  className="font-body-regular text-black text-sm mt-4"
                >
                  {quickLink.search_quick_links_link_title
                    ? quickLink.search_quick_links_link_title
                    : quickLink.search_quick_links_link_link_to.name}
                </a>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

const mapStateToProps = (state) => {
  const props = {
    showOffCanvas: state.header.showOffCanvas,
  };

  return props;
};

function mapDispatchToProps(dispatch) {
  const actions = {
    setShowOffCanvas,
  };

  const actionMap = {
    actions: bindActionCreators(actions, dispatch),
  };

  return actionMap;
}

export default connect(mapStateToProps, mapDispatchToProps)(ResponsiveHeader);
